(function(){
   /********REMOVING UNWANTED ELEMENTS ON DIFFERENT SCREEN********/
  if(window.innerWidth >= 750){
    document.querySelectorAll(".desktop__hide")?.forEach(function(e){e.remove()});
  }else{
    document.querySelectorAll(".mobile__hide")?.forEach(function(e){e.remove()});
  }
  /******VIDEO PLAYING FUNCTIONALITY*****/

  const playTrigger = document.querySelectorAll("[playTrigger]");
  if(playTrigger.length > 0){
    playTrigger.forEach(function(e){
      e.addEventListener("click",function(){
        this.closest("[videoWrapper]").querySelector("video").play();
        this.classList.add("hidden");
      })
    })
  }

  const videoTriggers = document.querySelectorAll("[videoWrapper] video");
  if(videoTriggers.length > 0){
    videoTriggers.forEach(function(e){
      e.addEventListener("click",function(){
        if(!this.paused || !this.ended){
          this.pause();
          this.closest("[videoWrapper]").querySelector("[playTrigger]").classList.remove("hidden");
        }
      })
      e.addEventListener("ended",function(){
          this.closest("[videoWrapper]").querySelector("[playTrigger]").classList.remove("hidden");
          this.load();
      })
    })
  }
})();